// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__2gUB3","text":"SelectPayment_text__ExMW7","title":"SelectPayment_title__3hP0V","btn":"SelectPayment_btn__3B9QZ"};